import { useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ExtendedCategoryInterface } from "../../entities/Category";
import { useAppDispatch } from "../../store/store";
import { fetchAsideCategories } from "./slice/actions";
import { getAsideData } from "./slice/selectors";
import { AsideStyled } from "./AsideStyled";
import { setBreadcrumbs } from "../Breadcrumbs/slice/BreadcrumbsSlice";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import { TEST_ID } from "../../shared/testid";
import { getTenantCredentials } from "../Tenant/selectors";

const Aside = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { asideCategories = [] } = useSelector(getAsideData);
    const credentials = useSelector(getTenantCredentials);
  const { contextLanguage }: TranslationContextInterface =
    useContext(TranslationContext);

  useEffect(() => {
    dispatch(fetchAsideCategories({ params: { limit: 10 } }));
  }, [dispatch, contextLanguage]);

  useEffect(() => {
    const activeAsideItem = asideCategories.find(
      (item) => item.to === location.pathname,
    );
    
    if (activeAsideItem) {
      dispatch(
        setBreadcrumbs({
          name: activeAsideItem.name,
          level: 0,
          link: activeAsideItem.to,
        }),
      );
      const savedParentId = localStorage.getItem('activeCategoryParentId');

      if (!activeAsideItem.id || (savedParentId && activeAsideItem.id.toString() !== savedParentId)) {
        localStorage.removeItem('activeCategoryId'); // Reset activeCategoryId if it doesn't match the active aside item
        localStorage.removeItem('activeCategoryParentId'); // Reset activeCategoryParentId
      }
    }
  }, [asideCategories, location, dispatch]);

  return (
    <AsideStyled>
      <div className="aside-items" data-testid={TEST_ID.ASIGE.CATEGORIES}>
        {asideCategories?.map(
          (category: ExtendedCategoryInterface, index: number) => {
            if(credentials?.countryId === 31 &&[1, 2, 4].includes(category.id)){
              return null;
            }
            const categoryName = category.name;

            let isActive = false;
            if (category.to === "/") {
              isActive = location.pathname === category.to;
            } else {
              isActive = location.pathname.startsWith(category.to);
            }

            const indexOrder = index + 1;

            return (
              <NavLink
                key={category.id}
                draggable={false}
                to={category.to}
                className={`aside-item ${isActive ? "active" : ""}`}
                style={{ color: isActive ? "#282828" : "#BFBFBF" }}
                tabIndex={indexOrder}
                data-testid={`${TEST_ID.ASIGE.CATEGORY}-${category.id}`}
              >
                <div className="sidear-item__icon">
                  <img
                    className="side-bar-icon"
                    alt=""
                    draggable={false}
                    src={isActive ? category.activeImg : category.inactiveImg}
                  />
                </div>
                <div className="aside-item__name">{categoryName}</div>
              </NavLink>
            );
          },
        )}
      </div>
    </AsideStyled>
  );
};

export default Aside;
